import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInsightsService } from './app-insights.service';
import { AppService } from './app.service';
import { IPricingCategory, ISaveDeleteResponse } from '../Shared/interface';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PricingCategoryService {

  private baseURL = this.appService.config.apiBaseUrl;
  pricingCategoryList = [];

  constructor(private http: HttpClient,
    private appinsights: AppInsightsService,
    private appService: AppService) { }

  getPricingCategoryList(): Observable<IPricingCategory[]> {
    return this.http.get<IPricingCategory[]>(
      `${this.baseURL}/PricingCategory/GetPricingCategoryList`,
      { observe: 'response' }).pipe(
        map(res => {
          this.pricingCategoryList = res.body as IPricingCategory[];
          return this.pricingCategoryList;
        }),
        catchError(this.handleError)
      );
  }

  getPricingCategoryListForOp(): Observable<IPricingCategory[]> {
    return this.http.get<IPricingCategory[]>(
      `${this.baseURL}/PricingCategory/GetPricingCategoryListForOp`,
      { observe: 'response' }).pipe(
        map(res => {
          this.pricingCategoryList = res.body as IPricingCategory[];
          return this.pricingCategoryList;
        }),
        catchError(this.handleError)
      );
  }

  deletePricingCategorySetting(id: number) {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/PricingCategory/DeletePricingCategory?pricingCategoryId=${id}`, options);
  }

  savePricingCategory(model: IPricingCategory): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let rentRaiseUrl = '';
    if (model.PricingCategoryId == 0) {
      rentRaiseUrl = `${this.baseURL}/PricingCategory/CreatePricingCategory`;
    } else {
      rentRaiseUrl = `${this.baseURL}/PricingCategory/UpdatePricingCategory`;
    }

    return this.http.post<ISaveDeleteResponse>(rentRaiseUrl, model, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
      console.error('server error:', error);
      if (error.error instanceof Error) {
          const errMessage = error.error.message;
          this.appinsights.logEvent(errMessage);
          return throwError(errMessage);
      }
      return throwError(error || 'Node.js server error');
  }
}
